import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-manual-dipping-view-results',
	standalone: false,
	templateUrl: './manual-dipping-view-results.component.html',
	styleUrl: './manual-dipping-view-results.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManualDippingViewResultsComponent implements OnInit {
	mdTaskID!: number | null;

	constructor(private route: ActivatedRoute) {}

	ngOnInit(): void {
		this.mdTaskID = Number(this.route.snapshot.paramMap.get('id'));
	}

}
